export default {
    state: {
        error: null,
        loading: false,
        showFilterDrawer: false,
        unsavedChanges: false,
    },
    getters: {
        error: state => {
            return state.error;
        },
        loading: state => {
            return state.loading;
        },
        unsavedChanges: state => {
            return state.unsavedChanges;
        }
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },
        setError(state, payload) {
            state.error = payload;
        },
        clearError(state) {
            state.error = null;
        },
        setUnsavedChanges(state, payload) {
            state.unsavedChanges = payload;
        }
    },
    actions: {
        clearError({commit}) {
            commit("clearError");
        },
        setError({commit}, payload) {
            commit("setError", payload);
        },
    }
};
